// extracted by mini-css-extract-plugin
export default {"header":"index_header_IEoa3","user":"index_user_Nhbno"};